import { catchResponseError } from 'packages/helpers/helpers';
import { parseUrl } from 'packages/helpers/urlUtils';

type Treatment = 'on' | 'off' | 'control';

const VALID_TREATMENTS: readonly string[] = ['on', 'off', 'control'];

const featureTreatmentService = {
    async fetchTreatment(domain: string | undefined, accessToken: string, feature: string): Promise<Treatment> {
        try {
            const response = await fetch(`${parseUrl(domain)}/v7/featuretreatments/treatment/${feature}`, {
                method: 'GET',
                headers: getHeaders(accessToken),
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch treatment for ${feature}: ${response.status}`);
            }

            const json = await response.json();

            if (!VALID_TREATMENTS.includes(json.treatment)) {
                throw new Error(`Unexpected treatment value for ${feature}: ${json.treatment}`);
            }

            return json.treatment as Treatment;
        } catch (e) {
            catchResponseError(e);

            throw e;
        }
    },
};

export default featureTreatmentService;

function getHeaders(accessToken: string) {
    return {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
    };
}
